import { useEffect, useState } from "react";

function useMediaQuery(mediaQueryString: string) {
  // defaults match to false
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    // when we get a medua query string, we attach the media query string to window
    // this happens inside a useEffect, which guarantees us that this will run on client (not during hydration)
    const mediaQueryList = window.matchMedia(mediaQueryString);
    const listener = () => setMatches(!!mediaQueryList.matches);
    listener();
    // add an event listener to when the screen resizes
    mediaQueryList.addListener(listener);
    // Deregister when component is dismounted
    return () => mediaQueryList.removeListener(listener);
  }, [mediaQueryString]);

  return matches;
}

export default useMediaQuery;
